/* import __COLOCATED_TEMPLATE__ from './with-discount-article-link.hbs'; */
/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    description: string;
  };
}

const WithDiscountArticleLink = templateOnlyComponent<Signature>();
export default WithDiscountArticleLink;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Billing::StripeMigration::Tooltips::WithDiscountArticleLink': typeof WithDiscountArticleLink;
  }
}
